import SectionPanel from "components/panels/SectionPanel/SectionPanel";
import React from "react";
import { AdvancingApproveFieldWithLabel } from "./AdvancingApproveFieldWithLabel";
import { SectionTemplateHeader } from "./SectionTemplateHeader";
import { SectionTemplateLoadingSkeleton } from "./SectionTemplateLoadingSkeleton";
import { AdvancingFormSection, AdvancingApproveSectionField } from "./types";

type AdvancingApproveSectionTemplateProps = { isLoading: true } | {
  isLoading?: false
  sections: Array<AdvancingFormSection<AdvancingApproveSectionField>>
}

export const AdvancingApproveSectionTemplate = (props: AdvancingApproveSectionTemplateProps) => {
  // The explicit comparison narrows the props, strict null checks are off
  if (props.isLoading === true) return <SectionTemplateLoadingSkeleton rowCounts={[4, 3, 7, 5]} />;

  return <SectionPanel.Section key="section">
    {props.sections.filter(section => !section.hidden).map((section, idx) =>
      <SectionPanel.Panel
        key={section.key}
        id={section.key}
        // We don't want to shower the header on the first "Show" section
        header={idx > 0 ? <SectionTemplateHeader>{section.title}</SectionTemplateHeader> : undefined}
      >
        <div className="advancing-approve-section-template-grid">
          {section.fields.filter(field => !field.hidden).map(field =>
            <AdvancingApproveFieldWithLabel key={field.key} field={field} />
          )}
        </div>
      </SectionPanel.Panel>
    )}
  </SectionPanel.Section>;
};
